var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"mainApp"},[_c('v-main',{staticStyle:{"padding-top":"0px !important","margin-bottom":"50px"}},[_c('v-container',[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }